// extracted by mini-css-extract-plugin
export default {"image":"root_picture-module__image___kdLXT","wrapper":"root_picture-module__wrapper___S9oHI"};